/* eslint-disable no-shadow */
var AssetTrackingType;
(function (AssetTrackingType) {
    AssetTrackingType["ENTRY"] = "ENTRY";
    AssetTrackingType["RFID"] = "RFID";
    AssetTrackingType["BLUETOOTH"] = "BLUETOOTH";
    AssetTrackingType["GPS"] = "GPS";
})(AssetTrackingType || (AssetTrackingType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["EMPTY"] = "EMPTY";
    DeviceType["GENERIC"] = "GENERIC";
    DeviceType["RFID"] = "RFID";
    DeviceType["GPS"] = "GPS";
    DeviceType["BLUETOOTH"] = "BLUETOOTH";
    DeviceType["PADLOCK"] = "PADLOCK";
})(DeviceType || (DeviceType = {}));
var OrderAssetReason;
(function (OrderAssetReason) {
    OrderAssetReason["EMPTY"] = "EMPTY";
    OrderAssetReason["ENTRY"] = "ENTRY";
    OrderAssetReason["RFID"] = "RFID";
    OrderAssetReason["GPS"] = "GPS";
    OrderAssetReason["MANUAL"] = "MANUAL";
    OrderAssetReason["INSPECTED"] = "INSPECTED";
    OrderAssetReason["REASSIGNED"] = "REASSIGNED";
    OrderAssetReason["REPAIRED"] = "REPAIRED";
    OrderAssetReason["BROKEN"] = "BROKEN";
    OrderAssetReason["PIN"] = "PIN";
    OrderAssetReason["SELF_REPORTED"] = "SELF_REPORTED";
})(OrderAssetReason || (OrderAssetReason = {}));
var OrderAssetState;
(function (OrderAssetState) {
    OrderAssetState["EMPTY"] = "EMPTY";
    OrderAssetState["PICKEDUP"] = "PICKEDUP";
    OrderAssetState["RETURNED"] = "RETURNED";
    OrderAssetState["INSPECTED"] = "INSPECTED";
    OrderAssetState["COMPLETED"] = "COMPLETED";
})(OrderAssetState || (OrderAssetState = {}));
var AssetPhotoState;
(function (AssetPhotoState) {
    AssetPhotoState["EMPTY"] = "EMPTY";
    AssetPhotoState["BEFORE_INSPECTION"] = "BEFORE_INSPECTION";
    AssetPhotoState["AFTER_INSPECTION"] = "AFTER_INSPECTION";
    AssetPhotoState["GENERIC"] = "GENERIC";
    AssetPhotoState["AT_PICKUP"] = "AT_PICKUP";
    AssetPhotoState["AT_DELIVERY"] = "AT_DELIVERY";
})(AssetPhotoState || (AssetPhotoState = {}));
var AssetLockType;
(function (AssetLockType) {
    AssetLockType["EMPTY"] = "EMPTY";
    AssetLockType["IGLOO"] = "IGLOO";
    AssetLockType["IGLOO_WORKS"] = "IGLOO_WORKS";
})(AssetLockType || (AssetLockType = {}));
var AssetInspectionType;
(function (AssetInspectionType) {
    AssetInspectionType["INSPECTION"] = "INSPECTION";
    AssetInspectionType["MAINTENANCE"] = "MAINTENANCE";
    AssetInspectionType["SERVICE"] = "SERVICE";
})(AssetInspectionType || (AssetInspectionType = {}));
var AssetEventType;
(function (AssetEventType) {
    AssetEventType["INSPECTION"] = "INSPECTION";
    AssetEventType["MAINTENANCE"] = "MAINTENANCE";
    AssetEventType["SERVICE"] = "SERVICE";
    AssetEventType["MANUAL_CORRECTION"] = "MANUAL_CORRECTION";
    AssetEventType["RENTAL"] = "RENTAL";
    AssetEventType["BATTERY_UPDATE"] = "BATTERY_UPDATE";
})(AssetEventType || (AssetEventType = {}));
var AccessorySelectionType;
(function (AccessorySelectionType) {
    AccessorySelectionType["MANDATORY"] = "MANDATORY";
    AccessorySelectionType["PRE_SELECTED"] = "PRE_SELECTED";
    AccessorySelectionType["OPTIONAL"] = "OPTIONAL";
})(AccessorySelectionType || (AccessorySelectionType = {}));
var RequestOrigin;
(function (RequestOrigin) {
    RequestOrigin["ADMIN"] = "ADMIN";
    RequestOrigin["UNKNOWN"] = "UNKNOWN";
})(RequestOrigin || (RequestOrigin = {}));
var AssetLockPinCodeLogEventType;
(function (AssetLockPinCodeLogEventType) {
    AssetLockPinCodeLogEventType["CREATED"] = "CREATED";
    AssetLockPinCodeLogEventType["ACCESSED"] = "ACCESSED";
    AssetLockPinCodeLogEventType["VIEWED"] = "VIEWED";
    AssetLockPinCodeLogEventType["ERROR"] = "ERROR";
})(AssetLockPinCodeLogEventType || (AssetLockPinCodeLogEventType = {}));

export { AccessorySelectionType, AssetEventType, AssetInspectionType, AssetLockPinCodeLogEventType, AssetLockType, AssetPhotoState, AssetTrackingType, DeviceType, OrderAssetReason, OrderAssetState, RequestOrigin };
//# sourceMappingURL=enums.js.map
